import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DconConfigAPI } from 'src/app/features/dfte-grid-view/config/config';


@Component({
  selector: 'app-video-popup',
  templateUrl: './video-popup.component.html',
  styleUrls: ['./video-popup.component.scss']
})
export class VideoPopupComponent implements OnInit {

  public sourceLink: any;
  constructor(public dialogRef: MatDialogRef<VideoPopupComponent>) { }

  ngOnInit(): void {
    // this.sourceLink = "http://localhost:5007/Bot/downloadFile/video"
    this.sourceLink = DconConfigAPI.NODE_URL + DconConfigAPI.URL_PROPS.BOT_DOWNLOAD_VIDEO;
  }

  closePopup(){
    this.dialogRef.close();
  }

}
